import PropTypes from 'prop-types';
import React from 'react';
import { Button, PageHeader } from 'react-bootstrap';
import AuthorizedAction from '../../AuthorizedAction.js';
import { PlusButtonIcon } from '../../icons/PlusButtonIcon.jsx';
import SubHeader from '../../SubHeader.jsx';
import TemplatesTable from './TemplatesTable.jsx';

function Templates({
  onAddTemplate,
  onDeleteTemplate,
  onEditTemplate,
  templates,
}) {
  return (
    <React.Fragment>
      <PageHeader>
        <h1 className="text-center">Templates</h1>
      </PageHeader>
      <SubHeader flexJustify small>
        <p className="strong text-muted no-margin">
          Please select from the list of templates below that you would like to
          view.
        </p>
      </SubHeader>
      <TemplatesTable
        onDeleteTemplate={onDeleteTemplate}
        onEditTemplate={onEditTemplate}
        templates={templates}
      />
      <AuthorizedAction action="create" subject="linkedFileTemplate">
        <div className="component-margin">
          <Button bsStyle="success" onClick={onAddTemplate}>
            <PlusButtonIcon />
            Add Template
          </Button>
        </div>
      </AuthorizedAction>
    </React.Fragment>
  );
}

Templates.propTypes = {
  onAddTemplate: PropTypes.func.isRequired,
  onDeleteTemplate: PropTypes.func.isRequired,
  onEditTemplate: PropTypes.func.isRequired,
  templates: PropTypes.array.isRequired,
};

export default Templates;
